import { LogoV2 } from '@/components/common/logo'
import { Box, Stack, Tooltip, Typography } from '@mui/material'
import { motion } from 'framer-motion'
import { useTranslations } from 'next-intl'
import { useProductDetailV2State } from '../../contexts/product-detail'
import { useSizeGuideContext } from '../../contexts/side-guide-context'
// const RECOMMENDED_OPTION = ['Quần Jean - 36', 'Sơ mi - XL', 'Quần tây - 36']

interface RecommendSizesProps {
  sizes: string[]
}
export const RecommendSizes = ({ sizes }: RecommendSizesProps) => {
  const t = useTranslations()
  const { product, handleOptionChange, sortedOptions } = useProductDetailV2State()
  const { handleCloseSideGuide } = useSizeGuideContext()
  const RECOMMENDED_OPTION =
    sizes.length > 0
      ? [`${product?.name ? product?.name + ' - ' : ''}${sizes?.[0]}`]
      : ['Chưa có đề xuất size cho sản phẩm ' + (product?.name || '')]

  const handleAssignRecommendedSize = (sizes: string[]) => {
    if (sizes?.length && sortedOptions?.length) {
      const optionSize = sortedOptions?.find((option) => option?.attribute_code === 'size')
      if (optionSize) {
        const matchSize = optionSize?.values?.find((option) => option?.label === sizes?.[0])
        if (matchSize) {
          handleOptionChange('size', matchSize?.uid)
        }
      }
    }
    handleCloseSideGuide()
  }
  return (
    <Stack
      initial={{
        opacity: 0,
        height: 0,
        overflow: 'hidden',
      }}
      animate={{
        opacity: 1,
        height: 'auto',
        overflow: 'visible',
        transition: {
          height: {
            duration: 0.3,
            ease: 'easeOut',
          },
          opacity: {
            duration: 0.25,
            delay: 0.1,
            ease: 'easeIn',
          },
        },
      }}
      exit={{
        opacity: 0,
        height: 0,
        overflow: 'hidden',
        transition: {
          height: {
            duration: 0.3,
            ease: 'easeIn',
          },
          opacity: {
            duration: 0.2,
            ease: 'easeOut',
          },
        },
      }}
      component={motion.div}
      width={'100%'}
      sx={{ padding: { xs: '12px', md: '16px' }, borderRadius: '8px', border: '1px dashed #BBBBBA' }}
      spacing={1}
    >
      <Stack direction={'row'} spacing={1} alignItems={'center'}>
        <Typography fontSize={{ xs: '1.25rem', md: '1.5rem' }} fontWeight={600}>
          {t('Gợi ý chọn size của')}
        </Typography>
        <LogoV2 props={{ sx: { height: { xs: '16px', md: '18px' } } }} />
        <Typography fontSize={{ xs: '1.25rem', md: '1.5rem' }} fontWeight={600}>
          :
        </Typography>
      </Stack>
      <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'space-between'}>
        <Typography variant="body2" fontWeight={300}>
          {t('Chúng tôi đề xuất cho bạn nên chọn size')}:{' '}
        </Typography>
        <Tooltip placement="top" title={'Click để chọn size gợi ý'}>
          <Typography variant="body2" component="span" fontWeight={600} sx={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleAssignRecommendedSize(sizes)}>
            Áp dụng
          </Typography>
        </Tooltip>
      </Stack>
      <Stack rowGap={1} direction={'row'} gap={1} alignItems={'center'} flexWrap={'wrap'}>
        {RECOMMENDED_OPTION.map((option) => (
          <Tooltip placement="top" title={'Click để chọn size gợi ý'} key={option}>
            <Box
              sx={{
                padding: '8px 16px',
                borderRadius: '999px',
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
                cursor: 'pointer',
              }}
              onClick={() => handleAssignRecommendedSize(sizes)}
            >
              <Typography color="inherit" variant="body2" fontWeight={600}>
                {option}
              </Typography>
            </Box>
          </Tooltip>
        ))}
      </Stack>
      <Typography variant="caption" fontWeight={600}>
        {t('recommended-size-text')}{' '}
      </Typography>
    </Stack>
  )
}
